<template>
  <div id="user-manage-employees">
    <div class="ipub-h1 relative line-h-40 mar-b-20">
      Manage Users
      <div class="right-option ipub-p1">
        <ipub-button v-if="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.EXPORT')"
                     @click="exp"
                     type="primary">
          Export
        </ipub-button>
      </div>
    </div>
    <div class="filter mar-b-30">
      <site-search-group class="mar-b-16"
                         v-model.trim="params.query"
                         placeholder="Search by users' name, email"
                         @search="getList()"
                         @clear="handleClear" />
      <div class="filter-items">
        <span class="ipub-p2 fw-bd">Roles</span>
        <ipub-select class="mar-l-20"
                     style="width:600px"
                     v-model="roleIdListArr"
                     mode="multiple"
                     search
                     @search="getRoles"
                     placeholder="Select Roles"
                     @change="getList()">
          <ipub-select-option v-for="value in roles"
                              :key="value.id"
                              :value="value">
            {{value.journal&&value.journal.name}} {{value.name}}
          </ipub-select-option>
        </ipub-select>
        <span class="mar-l-20 ipub-p2 fw-bd  ipub-nowrap">Country / Territory</span>
        <ipub-select v-model="params.countryCode"
                     @change="getList()"
                     search
                     :clear="true"
                     @search="countrySearch"
                     style="width:240px"
                     class="mar-l-20"
                     placeholder="Select Country / Territory">
          <ipub-select-option v-for="item in countryList"
                              :value="item.code"
                              :key="'countryList'+item.code">
            {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
          </ipub-select-option>
        </ipub-select>
        <!-- <span class="mar-l-20">Section</span>
        <ipub-select placeholder="Select Section"
                     v-model="params.sectionIdList"
                     class="mar-l-20"
                     style="width:240px"
                     :tree="true"
                     @change="getList()"
                     :options="sectionList" /> -->
      </div>
    </div>
    <div class="page-content">

      <div class="page-content-table">
        <ipub-table :columns="columns"
                    fixed
                    :empty="{icon:'iconuser'}"
                    emptyText="There is no user."
                    @order="setOrder"
                    :pagination="pagination"
                    :dataSource="dataSource">
          <template v-slot:email="{ record }">
            <ipub-tooltip>
              <div slot="title">{{record.email}}</div>
              <span class="ipub-c-p link-color"
                    @click="detail(record)">{{record.email}}</span>
            </ipub-tooltip>
          </template>
          <template v-slot:section="{ text }">
            <ipub-tooltip v-if="text&&text.length"
                          style="width:100%"
                          placement="bottomLeft"
                          omis="omis"
                          :label="`${text.map((item)=>{return `${item.journal?item.journal.name+' ':''}${item.name}`}).join(', ')}`" />
            <template v-else>- -</template>
          </template>
          <template v-slot:status="{text}">
            <template v-if="text">
              <ipub-label cover
                          type="success"
                          size="small">Abled</ipub-label>
            </template>
            <template v-else>
              <ipub-label cover
                          type="danger"
                          size="small">Disabled</ipub-label>
            </template>
          </template>
          <template v-slot:actions="{ record }">
            <ipub-tooltip class="border-right">
              <div slot="title">Details</div>
              <ipub-icon type="iconViewDetails"
                         @click="detail(record)" />
            </ipub-tooltip>
            <template v-if="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_USERS.DISABLE')">
              <ipub-tooltip v-if="record.enabled">
                <div slot="title">Disable</div>
                <ipub-icon type="iconDisable"
                           @click="able(record)" />
              </ipub-tooltip>
              <ipub-tooltip v-else>
                <div slot="title">Able</div>
                <ipub-icon type="iconAble"
                           @click="able(record)" />
              </ipub-tooltip>
            </template>
          </template>
        </ipub-table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
